import Utils from 'src/utils';
import { ABSENCES_FLAG } from 'src/constants/workTimeService';
import dayjs from 'dayjs';
import { WTS_MOMENT_DATE_MASK } from 'src/constants/dayjs';
import { isNil, uniq } from 'ramda';
class PutMultipleEventsToPlannerV2Adapter {
    static adapt(rawRequest, params) {
        const { skipOverlapping = true, excludeWeekends = false } = params;
        const request = rawRequest.map(Utils.objects.capitalizeObjectKeysRecursively);
        const jobs = [];
        const absences = [];
        request.forEach((item) => {
            // @ts-ignore IsLeave is added in Planner component
            if (item.IsLeave || item.LeaveId) {
                absences.push(PutMultipleEventsToPlannerV2Adapter.adaptAbsenceItem(item));
            }
            else {
                jobs.push(PutMultipleEventsToPlannerV2Adapter.adaptJobItem(item));
            }
        });
        return {
            jobs: {
                SkipOverlapping: skipOverlapping,
                ExcludeWeekends: excludeWeekends,
                JobItems: uniq(jobs)
            },
            absences: {
                ExcludeWeekends: excludeWeekends,
                AbsenceItems: uniq(absences)
            }
        };
    }
    static adaptJobItem(job) {
        const { start, end } = PutMultipleEventsToPlannerV2Adapter.getUpdatedEventPeriod(job);
        return {
            Comments: job.Comments,
            DepartmentId: Number(job.DepartmentId),
            End: end,
            Id: Number(job.Id),
            IsAdditionalWork: job.IsAdditionalWork,
            IsRestricted: job.IsRestricted,
            JobId: Number(job.JobId),
            ShiftId: Number(job.WorkShiftId),
            Start: start,
            UserId: Number(job.UserId),
            WorkSiteId: job.WorksiteId !== null ? Number(job.WorksiteId) : null
        };
    }
    static adaptAbsenceItem(absence) {
        const { start, end } = PutMultipleEventsToPlannerV2Adapter.getUpdatedEventPeriod(absence);
        const endIsInclusive = end.endsWith('T23:59:59');
        return {
            Comments: absence.Comments,
            DepartmentId: absence.DepartmentId,
            End: endIsInclusive ? dayjs(end).add(1, 'day').startOf('day').format(WTS_MOMENT_DATE_MASK) : end,
            Id: absence.Id,
            IsDeleted: absence.Flags === ABSENCES_FLAG.Cancelled,
            IsPlanned: absence.Flags === ABSENCES_FLAG.Planned,
            IsRestricted: absence.IsRestricted ?? false,
            JobId: Number(absence.LeaveId),
            Start: start,
            UserId: absence.UserId
        };
    }
    static getUpdatedEventPeriod(event) {
        const isLeave = !isNil(event.LeaveId);
        const startDate = event.StartDate?.split('T')[0] || event.StartDateTime?.split('T')[0];
        const startTime = event.StartDateTime?.split('T')[1] || `${event.StartTime}:00`;
        let start = `${startDate}T${startTime}`;
        const endDate = event.EndDate?.split('T')[0] || event.EndDateTime?.split('T')[0];
        const endTime = event.EndDateTime?.split('T')[1] || `${event.EndTime}:00`;
        let end = `${endDate}T${endTime}`;
        if (start >= end || isLeave)
            end = dayjs(end).add(1, 'day').format(WTS_MOMENT_DATE_MASK);
        if (isLeave) {
            start = dayjs(start).startOf('day').format(WTS_MOMENT_DATE_MASK);
            end = dayjs(end).startOf('day').format(WTS_MOMENT_DATE_MASK);
        }
        return { start, end };
    }
}
export default PutMultipleEventsToPlannerV2Adapter;
